import styled, { css } from 'styled-components'
import { CSS } from 'ui/helpers'

const TriggerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: var(--theme-colors-global-general-main);
  border-radius: 4px;
  padding: 28px 50px;
`

const TriggerText = styled.span`
  font: var(--theme-typography-h5-regular);
`

const TriggerButtonWrapper = styled.div`
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  svg {
    transition: fill 0.15s;
    fill: var(--theme-colors-theme-brand-darker);
  }

  &:focus-visible {
    svg {
      fill: var(--theme-colors-theme-brand-darkest);
    }
  }

  &:hover {
    svg {
      fill: var(--theme-colors-theme-brand-primary);
    }
  }

  &:active {
    svg {
      fill: var(--theme-colors-theme-brand-darkest);
    }
  }
`

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 56px 24px;
  gap: 20px;
`

const Title = styled.h5`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.h5.semiBold)};
`

const RatingButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
`

const RatingButton = styled.span<{ $selected?: boolean }>`
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    fill: var(--theme-colors-global-grey-grey100);
  }

  &:hover {
    svg {
      fill: var(--theme-colors-theme-brand-transparent-opacity12);
    }
  }

  ${({ $selected }) =>
    $selected &&
    css`
      svg {
        fill: var(--theme-colors-theme-brand-transparent-opacity12);
        color: var(--theme-colors-theme-brand-darkest);
      }
    `}
`

const ReactionTextWrapper = styled.div`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)};
  min-height: 20px;
  display: block;
`

const ReactionText = styled.label``

const ReactionErrorText = styled.label`
  color: var(--theme-colors-theme-negative-darker);
`

const FooterButtons = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;

  button {
    display: block;
    width: calc(50% - 6px);
  }
`

export const s = {
  TriggerWrapper,
  TriggerText,
  TriggerButtonWrapper,
  DialogContent,
  Title,
  RatingButtonsWrapper,
  RatingButton,
  ReactionTextWrapper,
  ReactionText,
  ReactionErrorText,
  FooterButtons
}
